import { c as _c } from "react/compiler-runtime";
import Source from "@mui/icons-material/Source";
import { Tooltip } from "@mui/material";
import Image from "next/image";
import React from "react";
import { IconButton } from "#/shared/ui/atoms/IconButton";
const ICON_SIZE = 24;
type SiteData = {
  title: string;
  icon: React.ReactNode;
};
const getSiteFromUrl = (url: string): SiteData => {
  const data = new URL(url);
  const name = data.hostname.split(".").at(-2);
  const result: SiteData = {
    title: "",
    icon: null
  };
  switch (name) {
    case "leetcode":
      result.title = "Open this problem on LeetCode";
      result.icon = <Image src="/LeetCode_logo_rvs.png" alt="LeetCode Logo" height={ICON_SIZE} width={ICON_SIZE} style={{
        marginTop: "1px"
      }} />;
      break;
    default:
      result.title = `Open this problem on ${name}`;
      result.icon = <Source fontSize="small" />;
  }
  return result;
};
type ProblemLinkButtonProps = {
  problemLink: string;
};
export const ProblemLinkButton: React.FC<ProblemLinkButtonProps> = t0 => {
  const $ = _c(10);
  const {
    problemLink
  } = t0;
  let t1;
  if ($[0] !== problemLink) {
    t1 = getSiteFromUrl(problemLink);
    $[0] = problemLink;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const site = t1;
  let t2;
  if ($[2] !== problemLink) {
    t2 = event => {
      event.preventDefault();
      window.open(problemLink, "_blank", "noopener,noreferrer");
    };
    $[2] = problemLink;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== site.icon || $[5] !== t2) {
    t3 = <IconButton icon={site.icon} onClick={t2} />;
    $[4] = site.icon;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== site.title || $[8] !== t3) {
    t4 = <Tooltip title={site.title} arrow={true}>{t3}</Tooltip>;
    $[7] = site.title;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};